import { createBrowserRouter } from "react-router-dom";
import Root from "../layout/Root";
import Blog from "../Pages/Blog";
import Home from "../Pages/Home";

export const router = createBrowserRouter([
    {
        path: '/',
        element:<Root></Root>,
        children: [
            {
                path: '/',
                element:<Home></Home>
            },
            {
                path: '/blogs',
                element:<Blog></Blog>
            }
        ]
    }
]);